import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const PayrollSavePayment = ({
  toggleOffCanvasCtc,
  setIsOffCanvasOpenCtc,
  isOffCanvasOpenCtc,
  data,
  fetchPayrollDetails,
}) => {
  const { baseUrl, openToast } = useGlobalContext();
  const [paymentRecords, setPaymentRecords] = useState(
    data?.map((item) => ({
      staffId: item?.staffDetails?.id,
      date: new Date().toISOString(),
      amount: 0,
      type: "SALARY",
      status: "SAVED",
      fullPayment: false,
      salaryDetailsId: item?.staffDetails?.SalaryDetails[0]?.id || "",
    }))
  );

  const handleAmountChange = (id, value) => {
    setPaymentRecords((prev) =>
      prev.map((record) =>
        record.staffId === id
          ? {
              ...record,
              amount: value ? parseFloat(value) : 0,
              fullPayment: false,
            }
          : record
      )
    );
  };

  const handleFullPaymentToggle = (id, pendingAmount) => {
    setPaymentRecords((prev) =>
      prev.map((record) =>
        record.staffId === id
          ? {
              ...record,
              fullPayment: !record.fullPayment,
              amount: !record.fullPayment ? pendingAmount : 0,
            }
          : record
      )
    );
  };

  const handleSavePayment = async () => {
    try {
      // Filter out records with amount 0
      const recordsToSave = paymentRecords.filter(
        (record) => record.amount > 0
      );

      if (recordsToSave.length === 0) {
        openToast("No payments to save!");
        return;
      }

      // Send data to backend
      const response = await fetch(baseUrl + "payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          data: recordsToSave.map(
            ({ staffId, date, amount, type, status, salaryDetailsId }) => ({
              staffId,
              date,
              amount: parseFloat(amount),
              type,
              status,
              salaryDetailsId,
            })
          ),
        }),
      });

      if (response.status === 201) {
        openToast("Payments saved successfully!", "success");
        setIsOffCanvasOpenCtc();
      }
    } catch (error) {
      openToast("Failed to save payments. Please try again.", "error");
    }
  };

  return (
    <div
      className={`fixed top-[56px] right-0 w-full sm:w-[600px] z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
        isOffCanvasOpenCtc ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="relative w-full h-full">
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <h2 className="font-semibold text-[#000] text-[18px]">
            Save Payment
          </h2>
          <button className="text-[black]" onClick={setIsOffCanvasOpenCtc}>
            <CloseIcon />
          </button>
        </div>
      </div>

      <div className="p-[20px] w-full h-[81vh]">
        <div className="overflow-x-auto">
          <table className="border-collapse w-full min-w-[500px]">
            <thead>
              <tr className="shadow-cs">
                <th className="border-gray-200 px-4 py-2 border font-medium text-gray-600 text-left text-sm whitespace-nowrap">
                  Name
                </th>
                <th className="border-gray-200 px-4 py-2 border font-medium text-gray-600 text-left text-sm whitespace-nowrap">
                  Pending
                </th>
                <th className="border-gray-200 px-4 py-2 border font-medium text-gray-600 text-left text-sm whitespace-nowrap">
                  Full Payment
                </th>
                <th className="border-gray-200 px-4 py-2 border font-medium text-gray-600 text-left text-sm whitespace-nowrap">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={index}>
                  <td className="border-gray-200 px-4 py-2 border whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <span className="text-sm">{item?.name}</span>
                    </div>
                  </td>
                  <td className="border-gray-200 px-4 py-2 border whitespace-nowrap">
                    <span className="text-sm">₹{item?.pending}</span>
                  </td>
                  <td className="border-gray-200 px-4 py-2 border text-center whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={
                        paymentRecords.find(
                          (record) => record.staffId === item.staffDetails.id
                        )?.fullPayment || false
                      }
                      onChange={() =>
                        handleFullPaymentToggle(
                          item.staffDetails.id,
                          item.pending
                        )
                      }
                    />
                  </td>
                  <td className="relative border-gray-200 px-4 py-2 border text-center whitespace-nowrap">
                    <input
                      type="number"
                      className="border-gray-300 p-2 rounded w-full text-sm"
                      min={0}
                      max={item?.pending}
                      placeholder="Enter amount"
                      value={
                        paymentRecords.find(
                          (record) => record.staffId === item?.staffDetails?.id
                        )?.amount || ""
                      }
                      onChange={(e) =>
                        handleAmountChange(
                          item?.staffDetails?.id,
                          e.target.value
                        )
                      }
                      disabled={
                        paymentRecords.find(
                          (record) => record.staffId === item?.staffDetails?.id
                        )?.fullPayment
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bottom-[40px] sm:bottom-[20px] left-0 absolute w-full">
          <div className="flex justify-between px-[20px]">
            <button
              className="w-[48%] first-btn"
              onClick={setIsOffCanvasOpenCtc}
            >
              Cancel
            </button>
            <button className="w-[48%] second-btn" onClick={handleSavePayment}>
              Save Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollSavePayment;
